import { render, staticRenderFns } from "./DsfExamPractice.vue?vue&type=template&id=632e7efc&"
import script from "./DsfExamPractice.vue?vue&type=script&lang=js&"
export * from "./DsfExamPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632e7efc')) {
      api.createRecord('632e7efc', component.options)
    } else {
      api.reload('632e7efc', component.options)
    }
    module.hot.accept("./DsfExamPractice.vue?vue&type=template&id=632e7efc&", function () {
      api.rerender('632e7efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfExamPractice.vue"
export default component.exports